module.exports = __webpack_public_path__ + "img/interception.c420bbb3.svg";